import './ViewAreaSidebar.scss';
import { Layout } from 'antd';
import React, { useEffect, useState } from 'react';
import { SonarMenu } from '@ui/menu';
import { useLocation, useNavigate } from 'react-router-dom';
const { Sider } = Layout;
export const ViewAreaSidebar = ({ id, items }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [selected, setSelected] = useState([pathname]);
    useEffect(() => {
        setSelected([pathname]);
    }, [pathname]);
    return (React.createElement("div", { className: 'sidebar-container' },
        React.createElement(Sider, { className: 'view-area-sidebar', id: id, theme: 'light' },
            React.createElement(SonarMenu, { items: items, onClick: (info) => navigate(info.key), selectedKeys: selected }))));
};
